import DecoratedHeader from '../common/DecoratedHeader/DecoratedHeader';

export default DecoratedHeader;
